import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  exportComprovativoApoio(params?: any): Observable<Blob> {
    const httpParams = params
      ? new HttpParams({ fromObject: params })
      : this.params;

    return this.apiService.download(
      '/DocumentoExportar/ComprovativoApoio',
      httpParams
    );
  }

  exportComprovativoArrecadacaoFundo(id: any): Observable<Blob> {
    return this.apiService.download(
      `/DocumentoExportar/ComprovativoArreacadacaoFundo/${id}`,
    );
  }

  exportComprovativoDoacaoFundo(id: any): Observable<Blob> {
    return this.apiService.download(
      `/DocumentoExportar/ComprovativoDoacaoFundo/${id}`,
    );
  }
}
